module.exports = __webpack_public_path__ + "img/ta.f9539d1f.svg";